import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function DanishPastriesPage() {

    const heroData = [
        {
          title: "Danish Pastries",
          content: "Danish pastries are sweet, flaky baked goods made from laminated dough enriched with butter, milk, and eggs. Often filled with fruit, cream, or jam, they are known for their light, airy layers and rich flavor.",
          image: images.DanishPastriesHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Cinnamon Roll",
        content: "Soft roll swirled with cinnamon and sugar, topped with icing",
        price: 0,
        image: [
          images.DanishPastrie1,
        ]
      },
      {
        name: "Apple Turnover",
        content: "Flaky pastry filled with spiced apples",
        price: 0,
        image: [
          images.DanishPastrie2,
        ]
      },
      {
        name: "Strawberry Danish",
        content: "Light pastry topped with fresh strawberries",
        price: 0,
        image: [
          images.DanishPastrie3,
        ]
      },
      {
        name: "Peach Danish",
        content: "Buttery pastry with peach filling",
        price: 0,
        image: [
          images.DanishPastrie1,
        ]
      },
      {
        name: "Raspberry Danish",
        content: "Buttery pastry with fresh raspberries",
        price: 0,
        image: [
          images.DanishPastrie2,
        ]
      },
      {
        name: "Blueberry Danish",
        content: "Buttery pastry with fresh blueberries",
        price: 0,
        image: [
          images.DanishPastrie3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Raspberry Danish",
        image1: [
          images.DanishPastrie2,
        ],
        content1: "Buttery pastry with fresh raspberries",
        name2: "Blueberry Danish",
        image2: [
          images.DanishPastrie3,
        ],
        content2: "Buttery pastry with fresh blueberries"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
